{
  "chart": {
    "header": "Chart",
    "linkedDocumentsOutsideCategory": "Linked documents outside of this category",
    "showCategories": "Group by categories"
  }
}
